import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const login = (token) => {
        localStorage.setItem('BByteAuthToken', token);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem('BByteAuthToken');
        setIsAuthenticated(false);
    };

    useEffect(() => {
        const token = localStorage.getItem('BByteAuthToken');
        setIsAuthenticated(!!token);
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};